import clsx from "clsx";
import { MenuLeft } from "../components/layout/sider";
import { Header } from "../components/layout/header";
import * as React from "react";
import "../components/layout/newLayoutColors.css";
import "../components/layout/newLayout.css";
import { Footer } from "./footer";
import { useNMainHeight } from "../reactContexts/nMainHeightContext";
import { useAppSelector } from "../store/hooks";

interface Props extends React.PropsWithChildren {
  showLeftMenu?: boolean;
}
export const Layout: React.FC<Props> = ({ children, showLeftMenu = true }) => {
  const theme = useAppSelector((state) => state.theme.theme);

  const { setNMainHeight } = useNMainHeight();

  React.useEffect(() => {
    const onResize = () => {
      setNMainHeight(window.innerHeight);
    };
    onResize();
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);

  return (
    <>
      <section
        id={"page"}
        className={clsx({
          dark: theme === "dark",
          noSidebar: !showLeftMenu,
        })}
      >
        <header>
          <Header isMenuShown={showLeftMenu} />
        </header>
        {showLeftMenu ? (
          <>
            <nav className={clsx("main")}>
              <MenuLeft />
            </nav>
          </>
        ) : (
          ""
        )}
        <main>
          <section>{children}</section>
          <Footer />
        </main>
      </section>
    </>
  );
};
